// Helper function to convert Blob to Base64
export const blobToBase64 = (blob: Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = (): void => {
            const base64String = reader.result as string;
            // Remove the data URL prefix (e.g., "data:application/pdf;base64,")
            const base64 = base64String.split(",")[1];
            resolve(base64 as string);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};